import React from 'react';
import { useGallery } from '../hooks/useGallery';
import GalleryGrid from '../components/GalleryGrid';

export default function Galerie() {
  const { photos, loading, error } = useGallery();

  return (
    <main style={styles.page}>
      {/* Page header */}
      <div style={styles.pageHeader}>
        <div style={styles.pageHeaderInner}>
          <span style={styles.eyebrow}>Eindrücke</span>
          <h1 style={styles.heading}>Unsere Galerie</h1>
          <p style={styles.sub}>Bilder sagen mehr als tausend Worte – schauen Sie selbst!</p>
        </div>
        <div style={styles.waveWrapper}>
          <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{ display: 'block', width: '100%', height: '60px' }}>
            <path d="M0,30 C480,60 960,0 1440,30 L1440,60 L0,60 Z" fill="#ffffff"/>
          </svg>
        </div>
      </div>

      <div style={styles.inner}>
        {loading && <p style={styles.info}>Fotos werden geladen...</p>}
        {error && <p style={styles.errorText}>Fotos konnten nicht geladen werden.<br /><small>{error}</small></p>}
        {!loading && !error && <GalleryGrid photos={photos} />}
      </div>
    </main>
  );
}

const F = "'Inter', system-ui, sans-serif";

const styles = {
  page: { backgroundColor: 'white', minHeight: '70vh' },
  pageHeader: {
    position: 'relative',
    background: 'linear-gradient(160deg, #155d33 0%, #1e8449 100%)',
    padding: '4rem 1.5rem 5rem',
    textAlign: 'center',
  },
  pageHeaderInner: { maxWidth: '600px', margin: '0 auto', position: 'relative', zIndex: 1 },
  eyebrow: { fontSize: '0.75rem', fontFamily: F, fontWeight: '600', letterSpacing: '1.8px', textTransform: 'uppercase', color: 'rgba(255,255,255,0.65)' },
  heading: { color: 'white', fontFamily: F, fontSize: 'clamp(1.9rem,5vw,2.8rem)', fontWeight: '700', marginTop: '0.4rem', marginBottom: '0.7rem', letterSpacing: '-0.3px' },
  sub: { color: 'rgba(255,255,255,0.72)', fontFamily: F, fontSize: '1rem' },
  waveWrapper: { position: 'absolute', bottom: 0, left: 0, right: 0 },
  inner: { maxWidth: '1200px', margin: '0 auto', padding: '2.5rem 1.5rem 4rem' },
  info: { textAlign: 'center', color: '#1e8449', fontFamily: F, padding: '3rem', fontSize: '1rem' },
  errorText: { textAlign: 'center', color: '#dc3545', fontFamily: F, padding: '2rem' },
};
